import React from 'react';
import type { InventorySupplierInvoiceSummaryCounts } from '@/renderer/types/inventory';

export function SupplierInvoicesSummaryCards({
  summary,
}: {
  summary: InventorySupplierInvoiceSummaryCounts;
}) {
  const fmt = (n: number) =>
    n.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const cards = [
    { label: 'Total invoices', value: summary.totalInvoices.toLocaleString() },
    { label: 'Drafts', value: summary.draftInvoices.toLocaleString() },
    {
      label: 'Posted / active',
      value: summary.postedInvoices.toLocaleString(),
    },
    { label: 'Outstanding value', value: fmt(summary.totalOutstanding) },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="rounded-2xl border border-gray-200 bg-white px-4 py-4 shadow-sm"
        >
          <p className="text-sm text-gray-500">{card.label}</p>
          <p className="mt-2 text-2xl font-semibold text-gray-900">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
}
